var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImplantable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.52,
    height: 64.611,
    viewBox: "0 0 86.52 64.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Implantable",
    transform: "translate(-23.48 -201.802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Implantable_Other",
    "data-name": "Implantable Other",
    transform: "translate(-705.234 -243.391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11869",
    "data-name": "Group 11869",
    transform: "translate(729.234 472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16323",
    "data-name": "Path 16323",
    d: "M7.749,0,6.37,6.165H25.579L24.2,0Z",
    transform: "translate(27.026)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11868",
    "data-name": "Group 11868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11870",
    "data-name": "Group 11870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16324",
    "data-name": "Path 16324",
    d: "M18.03,0C14.1,0,10.455.7,8.394,1.84L.608,6.165H33.4L34.568.949,34.775,0ZM51.222,0l.215.949,1.169,5.217H85.39L77.608,1.84C75.548.7,71.9,0,67.972,0ZM33.286,7.1H0V27.021c.011,1.305,3.109,2.365,6.93,2.369H79.07c3.822,0,6.92-1.064,6.93-2.369V7.1H52.719",
    fill: "#5035ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16325",
    "data-name": "Path 16325",
    d: "M6.37,6.165H25.579L24.2,0H7.749Z",
    transform: "translate(27.026 0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16326",
    "data-name": "Path 16326",
    d: "M6.37,6.165H25.579L24.2,0H7.749Z",
    transform: "translate(27.026 0.001)",
    fill: "#98baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16327",
    "data-name": "Path 16327",
    d: "M25.771,1.366V9.429c0,.262-9.71-2.317-9.71-2.317S6.341,9.5,6.341,9.429V1.366",
    transform: "translate(26.907 5.129)",
    fill: "#98baff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11871",
    "data-name": "Group 11871",
    transform: "translate(796.292 483.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11865",
    "data-name": "Group 11865"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2743",
    "data-name": "Rectangle 2743",
    width: 12.957,
    height: 12.714,
    rx: 1,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11866",
    "data-name": "Group 11866",
    transform: "translate(1.937 1.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16297",
    "data-name": "Path 16297",
    d: "M3.507,0H0V3.507H3.507ZM2.922,2.922H.584V.584H2.922Z",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16298",
    "data-name": "Path 16298",
    d: "M2,2H3.169V3.169H2Z",
    transform: "translate(-0.831 -0.831)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16299",
    "data-name": "Path 16299",
    d: "M0,13.507H3.507V10H0Zm.584-2.922H2.922v2.338H.584Z",
    transform: "translate(0 -4.155)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16300",
    "data-name": "Path 16300",
    d: "M2,12H3.169v1.169H2Z",
    transform: "translate(-0.831 -4.986)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16301",
    "data-name": "Path 16301",
    d: "M10,0V3.507h3.507V0Zm2.922,2.922H10.584V.584h2.338Z",
    transform: "translate(-4.155)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16302",
    "data-name": "Path 16302",
    d: "M12,2h1.169V3.169H12Z",
    transform: "translate(-4.986 -0.831)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16303",
    "data-name": "Path 16303",
    d: "M1.169,7H0V8.169H1.753V7.584H1.169Z",
    transform: "translate(0 -2.909)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16304",
    "data-name": "Path 16304",
    d: "M7,9H8.169v1.169H7Z",
    transform: "translate(-2.909 -3.74)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16305",
    "data-name": "Path 16305",
    d: "M3,7H4.169v.584H3Z",
    transform: "translate(-1.247 -2.909)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16306",
    "data-name": "Path 16306",
    d: "M8.169,12H7v.584h.584v.584h.584V12Z",
    transform: "translate(-2.909 -4.986)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16307",
    "data-name": "Path 16307",
    d: "M5.584,7v.584H5v.584H6.169V7Z",
    transform: "translate(-2.078 -2.909)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16308",
    "data-name": "Path 16308",
    d: "M8,4h.584V5.169H8Z",
    transform: "translate(-3.324 -1.662)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16309",
    "data-name": "Path 16309",
    d: "M8.584,7.584v.584H9.753V7H8v.584Z",
    transform: "translate(-3.324 -2.909)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16310",
    "data-name": "Path 16310",
    d: "M7,6h.584v.584H7Z",
    transform: "translate(-2.909 -2.493)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16311",
    "data-name": "Path 16311",
    d: "M9,14h1.169v1.169H9Z",
    transform: "translate(-3.74 -5.817)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16312",
    "data-name": "Path 16312",
    d: "M7,14h.584v1.169H7Z",
    transform: "translate(-2.909 -5.817)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16313",
    "data-name": "Path 16313",
    d: "M9,11h.584v.584H9Z",
    transform: "translate(-3.74 -4.571)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16314",
    "data-name": "Path 16314",
    d: "M8.169,1.753V.584H7.584V0H7V2.338h.584V1.753Z",
    transform: "translate(-2.909)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16315",
    "data-name": "Path 16315",
    d: "M12,14h.584v1.169H12Z",
    transform: "translate(-4.986 -5.817)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16316",
    "data-name": "Path 16316",
    d: "M12,12h1.169v.584H12Z",
    transform: "translate(-4.986 -4.986)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16317",
    "data-name": "Path 16317",
    d: "M11,13h.584v.584H11Z",
    transform: "translate(-4.571 -5.402)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16318",
    "data-name": "Path 16318",
    d: "M10,12h.584v.584H10Z",
    transform: "translate(-4.155 -4.986)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16319",
    "data-name": "Path 16319",
    d: "M14,10v.584h.584v.584h.584V10Z",
    transform: "translate(-5.817 -4.155)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16320",
    "data-name": "Path 16320",
    d: "M14.584,13H14v1.753h1.169V13.584h-.584Z",
    transform: "translate(-5.817 -5.402)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16321",
    "data-name": "Path 16321",
    d: "M10,9.584v.584h1.753V9H10.584v.584Z",
    transform: "translate(-4.155 -3.74)",
    fill: "#444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16322",
    "data-name": "Path 16322",
    d: "M12,7v.584h1.169v.584h1.169V7Z",
    transform: "translate(-4.986 -2.909)",
    fill: "#444"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Implantable_Hardware",
    "data-name": "Implantable Hardware",
    transform: "translate(23.48 201.802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_15956",
    "data-name": "Path 15956",
    transform: "translate(-172.289 -145.7)",
    fill: "#4c36e4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 191.1513824462891 209.3114624023438 L 185.3510284423828 209.3114624023438 C 182.4010162353516 209.3114624023438 180.0010070800781 206.3392944335938 180.0010070800781 202.68603515625 L 180.0010070800781 166 L 180.0010070800781 165 L 181.0010070800781 165 L 195.5014343261719 165 L 196.5014343261719 165 L 196.5014343261719 166 L 196.5014343261719 202.68603515625 C 196.5014343261719 206.3392944335938 194.1014099121094 209.3114624023438 191.1513824462891 209.3114624023438 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 181.0010070800781 166 L 181.0010070800781 202.68603515625 C 181.0010070800781 205.7316284179688 182.9459228515625 208.3114624023438 185.3510284423828 208.3114624023438 L 191.1513824462891 208.3114624023438 C 193.5581207275391 208.3114624023438 195.5014343261719 205.7324676513672 195.5014343261719 202.68603515625 L 195.5014343261719 166 L 181.0010070800781 166 M 179.0010070800781 164 L 197.5014343261719 164 L 197.5014343261719 202.68603515625 C 197.5014343261719 206.8907165527344 194.6528167724609 210.3114624023438 191.1513824462891 210.3114624023438 L 185.3510284423828 210.3114624023438 C 181.8496246337891 210.3114624023438 179.0010070800781 206.8907165527344 179.0010070800781 202.68603515625 L 179.0010070800781 164 Z",
    stroke: "none",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10863",
    "data-name": "Group 10863",
    transform: "translate(5.813 29.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_15958",
    "data-name": "Path 15958",
    transform: "translate(-151.002 -241)",
    fill: "#99baff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 169.9117126464844 245.6684722900391 L 169.8516693115234 245.6684722900391 L 152.4506378173828 245.6684417724609 L 152.3331909179688 245.6684417724609 L 152.2189636230469 245.6412353515625 C 150.9136047363281 245.3303527832031 150.0019226074219 244.1760711669922 150.0019226074219 242.834228515625 C 150.0019226074219 241.4923553466797 150.9136199951172 240.3380584716797 152.2189788818359 240.0271911621094 L 152.3332061767578 240 L 152.4506378173828 240 L 169.8516693115234 240 L 169.9117584228516 240 L 169.9714050292969 240.0071868896484 C 171.3791809082031 240.1769714355469 172.4048919677734 241.4324340820312 172.3059234619141 242.834228515625 C 172.4048919677734 244.2361297607422 171.379150390625 245.4915924072266 169.9713287353516 245.6612854003906 L 169.9117126464844 245.6684722900391 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 152.4506378173828 241 C 151.6012878417969 241.2022552490234 151.0019226074219 241.9611663818359 151.0019226074219 242.834228515625 C 151.0019226074219 243.707275390625 151.6012878417969 244.4661560058594 152.4506378173828 244.6684417724609 L 169.8516693115234 244.6684722900391 C 170.7569274902344 244.5593566894531 171.4045257568359 243.7402496337891 171.3019714355469 242.834228515625 L 171.3019409179688 242.834228515625 C 171.4045257568359 241.92822265625 170.7569274902344 241.1091766357422 169.8516693115234 241 L 152.4506378173828 241 M 152.2157897949219 239 L 169.9718322753906 239 L 170.0911407470703 239.0143890380859 C 172.0046997070312 239.2451782226562 173.4052429199219 240.9338073730469 173.3077392578125 242.834228515625 C 173.4052581787109 244.7347869873047 172.0046539306641 246.4234466552734 170.0910034179688 246.6540985107422 L 169.9717559814453 246.6684722900391 L 152.2157592773438 246.6684417724609 L 151.9872741699219 246.614013671875 C 150.2295532226562 246.1954040527344 149.0019226074219 244.6410980224609 149.0019226074219 242.834228515625 C 149.0019226074219 241.0273132324219 150.2295684814453 239.4729919433594 151.9873199462891 239.0544128417969 L 152.2157897949219 239 Z",
    stroke: "none",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_15959",
    "data-name": "Path 15959",
    transform: "translate(-151.002 -293.663)",
    fill: "#99baff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 169.9117279052734 305.6685180664062 L 169.8516693115234 305.6685180664062 L 152.4506378173828 305.6685180664062 L 152.3331909179688 305.6685180664062 L 152.2189331054688 305.6412963867188 C 150.9135894775391 305.3304138183594 150.0019226074219 304.1760864257812 150.0019226074219 302.834228515625 C 150.0019226074219 301.4923095703125 150.9136199951172 300.3380126953125 152.218994140625 300.0271911621094 L 152.3332214355469 300 L 152.4506378173828 300 L 169.8516693115234 300 L 169.9116973876953 300 L 169.9712829589844 300.0071716308594 C 171.379150390625 300.1767883300781 172.4049072265625 301.4322509765625 172.3059234619141 302.8341979980469 C 172.4049377441406 304.2361145019531 171.3792114257812 305.4916076660156 169.9713439941406 305.6613159179688 L 169.9117279052734 305.6685180664062 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 152.4506378173828 301 C 151.6012878417969 301.2022399902344 151.0019226074219 301.9611511230469 151.0019226074219 302.834228515625 C 151.0019226074219 303.7073669433594 151.6012878417969 304.4662170410156 152.4506378173828 304.6685180664062 L 169.8516693115234 304.6685180664062 C 170.7569274902344 304.5593872070312 171.4045562744141 303.7402648925781 171.3019714355469 302.834228515625 L 171.3019409179688 302.834228515625 C 171.4045257568359 301.9282531738281 170.7569274902344 301.1090698242188 169.8516693115234 301 L 152.4506378173828 301 M 152.2158050537109 299 L 169.9717102050781 299 L 170.0909118652344 299.0143737792969 C 172.0046234130859 299.2449340820312 173.4052734375 300.93359375 173.3077545166016 302.834228515625 C 173.4053192138672 304.7348022460938 172.0047149658203 306.4234313964844 170.0910339355469 306.6541442871094 L 169.9717864990234 306.6685180664062 L 152.2157440185547 306.6685180664062 L 151.9872436523438 306.6140747070312 C 150.2295227050781 306.1954345703125 149.0019226074219 304.64111328125 149.0019226074219 302.834228515625 C 149.0019226074219 301.0272827148438 150.2295837402344 299.4729309082031 151.9873657226562 299.0543823242188 L 152.2158050537109 299 Z",
    stroke: "none",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_15960",
    "data-name": "Path 15960",
    transform: "translate(-151.002 -346.325)",
    fill: "#99baff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 169.9117431640625 365.66845703125 L 169.8516845703125 365.66845703125 L 152.45068359375 365.66845703125 L 152.3332366943359 365.66845703125 L 152.2189788818359 365.6412353515625 C 150.9136352539062 365.330322265625 150.0019683837891 364.176025390625 150.0019683837891 362.834228515625 C 150.0019683837891 361.4924011230469 150.9136352539062 360.3380737304688 152.2189788818359 360.0271606445312 L 152.3332366943359 359.9999389648438 L 152.4506988525391 359.9999389648438 L 169.8516998291016 360.0000305175781 L 169.9117279052734 360.0000305175781 L 169.9713439941406 360.0072021484375 C 171.379150390625 360.1768798828125 172.4048919677734 361.4323425292969 172.3059387207031 362.834228515625 C 172.4048919677734 364.236083984375 171.3791656494141 365.4915771484375 169.9713745117188 365.6612548828125 L 169.9117431640625 365.66845703125 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 169.8516845703125 364.66845703125 C 170.7569732666016 364.559326171875 171.404541015625 363.7402648925781 171.3019561767578 362.834228515625 C 171.404541015625 361.9281921386719 170.7569732666016 361.109130859375 169.8516845703125 361.0000305175781 L 152.45068359375 360.9999389648438 C 151.6013641357422 361.2022399902344 151.0019683837891 361.9610900878906 151.0019683837891 362.834228515625 C 151.0019683837891 363.7072448730469 151.6013641357422 364.4661560058594 152.45068359375 364.66845703125 L 169.8516845703125 364.66845703125 M 169.9718017578125 366.66845703125 L 152.2157897949219 366.66845703125 L 151.9872741699219 366.614013671875 C 150.2295684814453 366.1953430175781 149.0019683837891 364.6410522460938 149.0019683837891 362.834228515625 C 149.0019683837891 361.0273742675781 150.2295684814453 359.4730529785156 151.9872741699219 359.0543823242188 L 152.2157897949219 358.9999389648438 L 169.9717712402344 359.0000305175781 L 170.0909881591797 359.014404296875 C 172.004638671875 359.2450256347656 173.4052429199219 360.9336853027344 173.3077545166016 362.834228515625 C 173.4052429199219 364.7347412109375 172.0046539306641 366.4234008789062 170.0910491943359 366.6540832519531 L 169.9718017578125 366.66845703125 Z",
    stroke: "none",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_15961",
    "data-name": "Path 15961",
    transform: "translate(-151.002 -398.988)",
    fill: "#99baff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 169.9117431640625 425.66845703125 L 169.8516845703125 425.66845703125 L 152.45068359375 425.66845703125 L 152.333251953125 425.66845703125 L 152.2190246582031 425.6412658691406 C 150.9136505126953 425.3303833007812 150.0019683837891 424.1761169433594 150.0019683837891 422.834228515625 C 150.0019683837891 421.492431640625 150.9136352539062 420.338134765625 152.2189788818359 420.0272216796875 L 152.3332366943359 420 L 152.45068359375 420 L 169.8516845703125 420 L 169.9117279052734 420 L 169.9713439941406 420.0071716308594 C 171.379150390625 420.1768493652344 172.4048919677734 421.4323120117188 172.3059387207031 422.834228515625 C 172.4048919677734 424.236083984375 171.3791656494141 425.4915771484375 169.9713745117188 425.6612548828125 L 169.9117431640625 425.66845703125 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 152.45068359375 421 C 151.6013641357422 421.2023010253906 151.0019683837891 421.9611511230469 151.0019683837891 422.834228515625 C 151.0019683837891 423.7073059082031 151.6013031005859 424.4661865234375 152.45068359375 424.66845703125 L 169.8516845703125 424.66845703125 C 170.7569732666016 424.559326171875 171.404541015625 423.740234375 171.3019561767578 422.834228515625 C 171.404541015625 421.9281921386719 170.7569274902344 421.1091003417969 169.8516845703125 421 L 152.45068359375 421 M 152.2157897949219 419 L 169.9717712402344 419 L 170.0910034179688 419.0143737792969 C 172.004638671875 419.2449951171875 173.4052429199219 420.9336547851562 173.3077697753906 422.834228515625 C 173.4052581787109 424.7347412109375 172.0046691894531 426.4234008789062 170.0910491943359 426.6540832519531 L 169.9718017578125 426.66845703125 L 152.2158355712891 426.66845703125 L 151.9873657226562 426.6140441894531 C 150.2296142578125 426.1954650878906 149.0019683837891 424.6411437988281 149.0019683837891 422.834228515625 C 149.0019683837891 421.0274047851562 150.2295684814453 419.4730834960938 151.9872741699219 419.054443359375 L 152.2157897949219 419 Z",
    stroke: "none",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_15966",
    "data-name": "Path 15966",
    d: "M171.3,106v7.337a1.66,1.66,0,0,1-1.45,1.834h-17.4a1.659,1.659,0,0,1-1.45-1.834V106Z",
    transform: "translate(-145.186 -93.037)",
    fill: "#98baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15968",
    "data-name": "Path 15968",
    d: "M121.449,0h-5.8a1.244,1.244,0,0,0-1.015.551,9.789,9.789,0,0,1-7.686,3.264A9.788,9.788,0,0,1,99.263.55,1.244,1.244,0,0,0,98.248,0h-5.8A1.66,1.66,0,0,0,91,1.834V12.962a1.66,1.66,0,0,0,1.45,1.834h29a1.66,1.66,0,0,0,1.45-1.834V1.834A1.66,1.66,0,0,0,121.449,0Z",
    transform: "translate(-90.987 0)",
    fill: "#4c36e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Implantable_Hardware-2",
    "data-name": "Implantable Hardware",
    transform: "translate(23.48 201.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15956-2",
    "data-name": "Path 15956",
    d: "M195.5,166v36.686c0,3.046-1.943,5.625-4.35,5.625h-5.8c-2.405,0-4.35-2.58-4.35-5.625V166Z",
    transform: "translate(-172.289 -145.7)",
    fill: "#4c36e4",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10863-2",
    "data-name": "Group 10863",
    transform: "translate(5.813 29.472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15958-2",
    "data-name": "Path 15958",
    d: "M171.3,242.834a1.659,1.659,0,0,1-1.45,1.834h-17.4a1.886,1.886,0,0,1,0-3.668h17.4a1.659,1.659,0,0,1,1.45,1.834Z",
    transform: "translate(-151.002 -241)",
    fill: "#99baff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15959-2",
    "data-name": "Path 15959",
    d: "M171.3,302.834a1.66,1.66,0,0,1-1.45,1.834h-17.4a1.886,1.886,0,0,1,0-3.669h17.4a1.659,1.659,0,0,1,1.45,1.834Z",
    transform: "translate(-151.002 -293.663)",
    fill: "#99baff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15960-2",
    "data-name": "Path 15960",
    d: "M171.3,362.834a1.659,1.659,0,0,1-1.45,1.834h-17.4a1.886,1.886,0,0,1,0-3.669h17.4A1.659,1.659,0,0,1,171.3,362.834Z",
    transform: "translate(-151.002 -346.325)",
    fill: "#99baff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15961-2",
    "data-name": "Path 15961",
    d: "M171.3,422.834a1.659,1.659,0,0,1-1.45,1.834h-17.4a1.886,1.886,0,0,1,0-3.668h17.4A1.659,1.659,0,0,1,171.3,422.834Z",
    transform: "translate(-151.002 -398.988)",
    fill: "#99baff",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15966-2",
    "data-name": "Path 15966",
    d: "M171.3,106v7.337a1.66,1.66,0,0,1-1.45,1.834h-17.4a1.659,1.659,0,0,1-1.45-1.834V106Z",
    transform: "translate(-145.186 -93.038)",
    fill: "#98baff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15968-2",
    "data-name": "Path 15968",
    d: "M121.449,0h-5.8a1.244,1.244,0,0,0-1.015.551,9.789,9.789,0,0,1-7.686,3.264A9.788,9.788,0,0,1,99.263.55,1.244,1.244,0,0,0,98.248,0h-5.8A1.66,1.66,0,0,0,91,1.834V12.962a1.66,1.66,0,0,0,1.45,1.834h29a1.66,1.66,0,0,0,1.45-1.834V1.834A1.66,1.66,0,0,0,121.449,0Z",
    transform: "translate(-90.987 0)",
    fill: "#4c36e4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImplantable);
export default __webpack_public_path__ + "static/media/Implantable.b6965863dda76aff72bf0b300b4eaf24.svg";
export { ForwardRef as ReactComponent };